<template>
  <el-container class="jo-main-content">
    <rcSidebar v-if="layout == 'rc'"></rcSidebar>
    <sidebar v-else></sidebar>
    <jobody></jobody>
  </el-container>
</template>

<script>
  /* eslint-disable */
  import sidebar from './sidebar/sidebar.vue'
  import rcSidebar from './sidebar/sidebarRc.vue'
  import jobody from "./body/body";

  export default {
    components: {
      jobody,
      sidebar,
      rcSidebar
    },
    data() {
      return {
        height: 0
      }
    },
    mounted() {
//      MathJax.Hub.Queue(["Typeset", MathJax.Hub]);

      //禁止折行,两种特殊情况:正文和表格的不同格式的文本格式和是否存在兄弟节点

      if (this.layout == 'rc'){
        $('.el-container').css({'flex-direction':'column'})
      }
      this.GLOBAL.enchanceNoBreak();

      var popoverList = [];
      var that = this;

      var ifPopover = function () {
        popoverList = document.querySelectorAll(".el-popover");
        if (popoverList.length != 0) {
          for (var i in popoverList) {
            if (popoverList[i].style && popoverList[i].style.display != "none") {
              return true;
            }
          }
        }
        return false;
      }
      var scrollFunc = function (e) {
        // e是FF的事件。window.event是chrome/ie/opera的事件
        var e = e || window.event;
        if (e.wheelDelta || e.detail) {
          if (that.GLOBAL.tabId == 'carousel' && ifPopover()) {
            e.preventDefault();
            return false;
          }
        }
      }
      /*注册事件*/
      if (document.addEventListener) {
        //W3C FF
        document.addEventListener('DOMMouseScroll', scrollFunc, {passive: false});
      }
      //71以上版本Chrome
      document.addEventListener('mousewheel', scrollFunc, {passive: false});
      //IE/Opera/Chrome/Safari
      window.onmousewheel = document.onmousewheel = scrollFunc;
    },
    methods: {

    }
  }
</script>

<style>
  .jo-main-content {
    background-color: #fafafa;
    /*touch-action: none;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/maincontent.vue